import { User } from 'firebase/auth';

import { AdaptiveUserProfile } from '../utils/adaptiveModels';

type UserProfile = AdaptiveUserProfile;

export function getUserProfileFromLocalStorage(): UserProfile {
  const userProfile = localStorage.getItem('userProfile');

  if (!userProfile) {
    const userProfile: UserProfile = {
      email_opt_in: false,
    };
    saveUserProfileToLocalStorage(userProfile);
    return userProfile;
  }

  return JSON.parse(userProfile) as UserProfile;
}

export function saveUserProfileToLocalStorage(userProfile: UserProfile): void {
  for (const key in userProfile) {
    if (Object.prototype.hasOwnProperty.call(userProfile, key)) {
      const upKey = key as keyof UserProfile;
      if (userProfile[upKey] === '') {
        delete userProfile[upKey];
      }
    }
  }

  console.debug('Saving user profile to local storage', userProfile);
  localStorage.setItem('userProfile', JSON.stringify(userProfile));
}

export function updateUserProfileFromAuth(user: User): void {
  const userProfile = getUserProfileFromLocalStorage();

  userProfile.email = user.email ?? undefined;
  userProfile.full_name = user.displayName ?? undefined;

  saveUserProfileToLocalStorage(userProfile);
}
